export default "__VITE_ASSET__CditTFGQ__"